import { useState } from "react";
import { useServerSdk } from "../../RootNavigator/services/ServerSdk";
import { ImpactTrackingSectionDescriptor } from "./utilities";
import { ImpactTrackingSectionParams } from "@hpo/client/models/Archive";
import FieldsForm from "@hpo/client/utilities/fields/FieldsForm";
import TextField from "@hpo/client/utilities/fields/TextField";
import { useSubmitCallback } from "@hpo/client/utilities/useSubmitCallback";
import MultiSelectField from "@hpo/client/utilities/fields/MultiSelectField";
import Spacer from "@hpo/client/utilities/Spacer";
import Buttons from "@hpo/client/components/Buttons";
import Button from "@hpo/client/components/Button";
import ErrorToast from "@hpo/client/utilities/ErrorToast";
import T from "@hpo/client/components/text/Text";
import Divider from "@hpo/client/components/Divider";

type ImpactTrackingParamsProps = {
  params: Partial<ImpactTrackingSectionParams>;
  onChange: (params: ImpactTrackingSectionParams) => void;
  onDelete: () => void;
};

export default function ImpactTrackingParams(props: ImpactTrackingParamsProps) {
  const { params, onDelete, onChange } = props;
  const server = useServerSdk();
  const allPeriods = server.suspender.use(server.getPeriods_());
  const [title, setTitle] = useState<string | null>(params.title || null);
  const [periods, setPeriods] = useState<Array<string>>(params.periods || []);

  const [onSubmit, submission] = useSubmitCallback(() => {
    if (title === null) throw new Error("Titre manquant");
    if (periods === null) throw new Error("Périodes manquantes");
    onChange({ type: "impact-tracking", title, periods });
  }, [title, periods]);

  return (
    <FieldsForm onSubmit={onSubmit}>
      <ErrorToast error={submission.error} />
      <T style="section">{ImpactTrackingSectionDescriptor.title}</T>
      <Spacer />
      <T>{ImpactTrackingSectionDescriptor.description}</T>
      <Spacer />
      <Divider />
      <Spacer />
      <TextField
        value={title}
        label="Titre de la section"
        onChange={setTitle}
      />
      <Spacer />
      <MultiSelectField
        value={periods}
        label="Périodes à afficher"
        onChange={setPeriods}
        options={allPeriods}
        keyExtractor={(o) => o}
        renderOption={(o) => ({ label: o })}
      />
      <Spacer />
      <Buttons expand>
        <Button onClick={onDelete} label="Supprimer" style="danger" />
        <Button submit label="Valider" />
      </Buttons>
    </FieldsForm>
  );
}
